module.exports = __webpack_public_path__ + "img/logo_tesfri_white.bbf35c1b.png";